import { SOFTWARE } from '../constant/actionTypes';

const getSoftwareList = (state, action) => {
  switch (action.type) {
    case SOFTWARE.GET.INITIATE:
      return { isFetching: true, data: action.payload };
    case SOFTWARE.GET.SUCCESS:
      return { isFetching: false, data: action.payload };
    case SOFTWARE.GET.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return state || [];
  }
};

export default getSoftwareList;
